export const reg_mobile = /^1[3456789]\d{9}$/;
export const reg_email = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]+)$/




// WEBPACK FOOTER //
// ./src/common/utils/regs.js